import { BeforeYouSyncModal, BeforeYouSyncModalProps } from "./BeforeYouSyncModal"

export const BeforeYouSyncModalDji = (props: BeforeYouSyncModalProps) => {
    return (
        <BeforeYouSyncModal {...props}>
            <h4 className="text-gray-0 text-center mt-4">
                Before continuing, ensure all your flights have finished syncing to the cloud.
                <br />
                <br />
                <a
                    className="underline text-blue-500 hover:text-blue-300"
                    href="https://support.dji.com/help/content?customId=en-us03400010205&spaceId=34&re=GB&lang=en"
                    target="about:blank"
                >
                    How to sync from DJI Pilot 2
                </a>
                <br />
                <br />
                <a
                    className="underline text-blue-500 hover:text-blue-300"
                    href="https://support.dji.com/help/content?customId=en-us03400006773&spaceId=34&re=GB&lang=en"
                    target="about:blank"
                >
                    How to sync from DJI Fly
                </a>
            </h4>
        </BeforeYouSyncModal>
    )
}
